export default __webpack_public_path__ + "images/08a5b77fc36f0579d54475d7106ee4b1-pregnancy-loneliness.svg";